export default "__VITE_ASSET__e978460d__"